import { render, staticRenderFns } from "./LandmarkGuide.vue?vue&type=template&id=32c10a1c&scoped=true"
import script from "./LandmarkGuide.vue?vue&type=script&lang=js"
export * from "./LandmarkGuide.vue?vue&type=script&lang=js"
import style0 from "./LandmarkGuide.vue?vue&type=style&index=0&id=32c10a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c10a1c",
  null
  
)

export default component.exports